import { Card, Divider } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useAlerts } from '../../hooks/query/use-alerts';
import { AccessControlEventsTable } from '../organisms/access-control-events-table';

import { PageContainer } from '@/components/molecules/page-container';
import { PageHeader } from '@/components/molecules/page-header';
import { Pagination } from '@/components/organisms/pagination';
import { usePagination } from '@/hooks/use-pagination';
import { withPermissions } from '@/permissions/can';

const AccessControlEvents = () => {
  const { t } = useTranslation(['accessControlEvents']);

  const { page, perPage, changePage, changePerPage, setTotalItems, totalPages } = usePagination();

  const { data, isLoading, error, isFetching } = useAlerts({ page, perPage });

  useEffect(() => {
    if (data) {
      setTotalItems(data.total);
    }
  }, [data]);

  return (
    <PageContainer helmetPageTitle={t('accessControlEvents:tab')}>
      <PageHeader title={t('accessControlEvents:title')} />
      <Card
        variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}>
        <AccessControlEventsTable
          data={data?.resources || []}
          isLoading={isLoading}
          error={error?.response?.data?.message || ''}
        />
        <Divider sx={{ mt: 'auto' }} />
        <Pagination
          changePage={changePage}
          page={page}
          perPage={perPage}
          changePerPage={changePerPage}
          isFetching={isFetching}
          totalPages={totalPages}
        />
      </Card>
    </PageContainer>
  );
};

export default withPermissions(
  permissions => permissions.cannot('read', 'AccessControlEvents'),
  AccessControlEvents,
);
